import CloseIcon from "@mui/icons-material/Close";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";

const IntegrationGuideAlert = () => {
  const [openIntegrationGuideInfo, setIntegrationGuideInfo] = useState(true);
  const colors = useColors();
  return (
    <Collapse sx={{ width: "100%" }} in={openIntegrationGuideInfo}>
      <Alert
        severity="info"
        icon={
          <ErrorRoundedIcon sx={{ width: "20px", color: colors.info_dark }} />
        }
        sx={{
          backgroundColor: colors.info_8percent,
          border: "1px solid " + colors.info_16percent,
          borderRadius: "8px",

          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            sx={{}}
            onClick={() => {
              setIntegrationGuideInfo(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle
          sx={{
            margin: 0,
          }}
        >
          <Typography variant="subtitle1" sx={{ color: colors.info_dark }}>
            Integration Guide - View Only
          </Typography>
        </AlertTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: colors.text_primary,
            }}
          >
            This integration guide is in view-only mode. You can review the
            integration guide for reference, but no changes can be made.
          </Typography>
        </Box>
      </Alert>
    </Collapse>
  );
};

export default IntegrationGuideAlert;
